// extracted by mini-css-extract-plugin
export default {"container":"styles_container__OjR5p","question":"styles_question__2r-pD","content":"styles_content__C3mQY"};